module.exports = __webpack_public_path__ + "img/raintank-normal.e35a7790.svg";